import React from 'react'
import { FieldHookConfig, useField } from 'formik'
import { CustomSelect } from 'components'
import { biologicalSexList } from 'constants/gender'
import { useSignUpAnaytics } from 'hooks/useSignUpAnaytics'
import { useLocation } from 'react-router-dom'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type FormikCustomFieldProps = { className?: string; dataTestId?: string } & FieldHookConfig<any>

export const BiologicalSexCustomSelect = ({ className, dataTestId, ...props }: FormikCustomFieldProps) => {
    const [field, meta] = useField(props)
    const { dispatchAnalyticsEvent } = useSignUpAnaytics()
    const { pathname } = useLocation()
    const nameEvent = (pathName: string) => {
        if (pathName === '/recuperar-senha') {
            return 'reset_password'
        }
        return 'cadastro_web'
    }

    return (
        <CustomSelect
            data-testid={dataTestId}
            error={!!meta.touched && !!meta.error ? meta.error : ''}
            label="Sexo biológico"
            name={props.name}
            onBlur={e => {
                field.onBlur(e)
                dispatchAnalyticsEvent('personalDataOnFieldBlur', {
                    name: nameEvent(pathname),
                    fieldName: e.target.name,
                    errorMessage: meta.error,
                })
            }}
            onChange={field.onChange}
            options={biologicalSexList}
            value={field.value}
        />
    )
}
